import { useMutation, gql } from '@apollo/client'
import ReactGA from "react-ga4"

const csMutation = gql`
mutation($payload: JSONObject!) {
  cs(payload: $payload),
}
`

const useCsEvent = function() {
  const [trigger] = useMutation(csMutation, {
    onCompleted: (data) => {

    },
    errorPolicy: 'all'
  })
  return (payload) => {
    trigger({variables: {
      payload: {
        ...payload,
        ua: window?.navigator?.userAgent,
        url: window.location.pathname+window.location.search, 
      }
    }})
    ReactGA.event({
      category: payload.category,
      action: payload.action,
      label: payload.label,
    })
  }
}

export {
  useCsEvent
}


